import { RESET } from 'jotai/utils';

import { scrollPositionsAtom } from '@/hooks/useScrollMemory/state';

import {
  permissionsAppliedToTokenAtom,
  permissionsAtom,
  permissionsOnActualTokenAtom,
  permissionsWidgetInitializedAtom,
} from '@/utils/permissions-widget/state';

import { store } from './store';

// Import all resettable atoms
import { documentAtom } from '@/atoms/document';
import { licenseeLocationBaseAtom } from '@/atoms/licensee-location';
import { quizDraftAtom } from '@/atoms/quiz-draft';
import { searchBaseAtom } from '@/atoms/search';
import { trainTogetherModeBaseAtom } from '@/atoms/trainTogetherMode';
import { userPrefsAtom } from '@/atoms/userPrefs';
import {
  editPlanDraftAtom,
  procedureDraftAtom,
} from '@/routes/TrainingPlans/BuildPlans/state';
import { planBuildTimerAtom } from '@/routes/TrainingPlans/planBuildTimer';

/**
 * Resets all atomsWithStorage to their default values.
 * This clears persisted state from localStorage and resets atoms to initial state.
 *
 * @note When adding a new atomWithStorage, make sure to:
 * 1. Add its key to STORAGE_KEYS in storageKeys.ts
 * 2. Import the atom here
 * 3. Add a store.set(atom, RESET) call below
 */
export const resetAllStorageAtoms = () => {
  // Reset all atomsWithStorage using RESET
  store.set(documentAtom, RESET);
  store.set(userPrefsAtom, RESET);
  store.set(trainTogetherModeBaseAtom, RESET);
  store.set(searchBaseAtom, RESET);
  store.set(licenseeLocationBaseAtom, RESET);
  store.set(permissionsAtom, RESET);
  store.set(permissionsAppliedToTokenAtom, RESET);
  store.set(permissionsOnActualTokenAtom, RESET);
  store.set(permissionsWidgetInitializedAtom, RESET);
  store.set(quizDraftAtom, RESET);
  store.set(procedureDraftAtom, RESET);
  store.set(editPlanDraftAtom, RESET);
  store.set(planBuildTimerAtom, RESET);
  store.set(scrollPositionsAtom, RESET);
};
